import EStyleSheet from 'react-native-extended-stylesheet';

const borderWidth = 0;
export const styles = EStyleSheet.create({
    container: {
        padding: 0,
        backgroundColor: 'white',
        flexDirection: 'row',
        borderWidth,
        borderColor: 'red',
        justifyContent: 'flex-start',
        alignItems: 'center',
    },
    image: {
        width: 36,
        height: 36,
        borderWidth,
        borderColor: 'blue',
        flexGrow: 0,
    },
    text: {
        fontSize: 16,
        color: 'black',
        borderWidth,
        borderColor: 'red',
        flex: 1,
    },
    bold: {
        fontWeight: '600',
        fontFamily: '$sourceSansPropFontFamily_semibold',
    },
    textWrapper: {
        flexDirection: 'column',
    },
    item: {
        borderWidth,
        borderColor: 'green',
        paddingLeft: 0,
        justifyContent: 'space-between',
        flexDirection: 'row',
        flex: 1,
    },
    refreshItem: {
        flexGrow: 0,
        borderWidth,
        justifyContent: 'center',
        alignItems: 'center',
    },
});
